import { BaseIRemoteApi } from './api.base';

export class BoxIRemoteApi extends BaseIRemoteApi {
}